<template>
  <div class="product-badges critical-component-clear" />
</template>

<script>

/**
 * Vue: Product badges (product-badges)
 * -----------------------------------------------------------------------------
 * Product badge section that will take a tag and product badge image within the block settings.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {Array} blocks - Block data.
 *
 */
export default {
  name: 'ProductBadges',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
    blocks: {
      type: Array,
      default: () => ([]),
    },
  },

  updated() {
    window.cnvs.badges = [...this.blocks]
  },
}
</script>

<style lang="scss">
@import './product-badges';
</style>
